import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function CustomDatePicker(props: any) {
  const { hiddenHeaderLabel, fullWidth, size, slotProps, ...rest } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...rest}
        slotProps={{
          textField: {
            ...(slotProps?.textField ?? {}),
            size: size === "small" ? "small" : "medium",
            fullWidth: fullWidth,
          },
          layout: {
            ...(slotProps?.layout ?? {}),
            sx: {
              ...(slotProps?.layout?.sx ?? {}),
              ".MuiPickersCalendarHeader-root": {
                opacity: hiddenHeaderLabel ? 0 : 1,
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
